// Export database instance
export { db, getDb } from "./schema";
export type { ChatMessage } from "./schema";

